<template>
  <CustomModal
    :visible="visible"
    @update:visible="handleVisibilityChange"
    title="SuperAGI Voice Agent Terms"
    width="35vw"
  >
    <div
      :id="`${source}_voice_agent_terms_and_conditions`"
      class="flex flex-col gap-5 proxima_nova text-[13px] font-normal text_color leading-[18px]"
    >
      <div>
        By selecting 'Agree and Continue,' you acknowledge and agree to comply
        with the
        <a
          href="https://superagi.com/terms/"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold underline cursor-pointer hover:opacity-80"
          >SuperAGI Terms of Service</a
        >,
        <a
          href="https://superagi.com/voice-agent-policy/"
          target="_blank"
          rel="noopener noreferrer"
          class="font-semibold underline cursor-pointer hover:opacity-80"
          >SuperAGI Voice Agent Policy</a
        >, and all relevant laws and regulations, including but not limited to
        TCPA (U.S.), TRAI (India), PECR (UK/EU), and applicable Do Not Call
        guidelines in your region and the region of the recipient of your calls.
      </div>

      <div>
        AI voice calls are classified as robocalls and may only be used for
        calls where you have obtained
        <span class="font-semibold">explicit prior consent</span> from
        recipients or for
        <span class="font-semibold"
          >transactional communications with existing customers</span
        >. Cold calling is prohibited.
      </div>

      <div>
        You agree to obtain any necessary consent from call recipients before
        using Call Recording, Transcription, and Voicemail features of SuperAGI.
        You are responsible for ensuring compliance with legal requirements
        related to call recording, consent management, DNC list scrubbing, and
        call permissions in your region and the region of the recipients of your
        calls.
      </div>
    </div>

    <template #footer>
      <div class="flex flex-row items-center gap-2">
        <a-button
          class="secondary_medium"
          @click="handleUpdateVoiceAgentConsent(false)"
          >Cancel</a-button
        >
        <a-button
          class="primary_medium"
          @click="handleUpdateVoiceAgentConsent(true)"
          >Agree and Continue</a-button
        >
      </div>
    </template>
  </CustomModal>
</template>

<script setup>
import CallService from "@/src/api/CallService.js";
import CustomModal from "@/src/components/CustomModal.vue";
import store from "@/src/store/index.js";
import eventBus from "@/src/utils/eventBus.js";

const props = defineProps({
  source: { type: String, required: true },
  visible: { type: Boolean, required: true },
});

const emit = defineEmits(["update:visible"]);

const closeModal = () => {
  emit("update:visible", false);
};

const handleVisibilityChange = (newValue) => {
  if (!newValue) {
    eventBus.emit("voice-agent-consent-cancel");
    closeModal();
  }
};

const handleUpdateVoiceAgentConsent = async (status) => {
  try {
    const payload = {
      voice_agent_consent: status,
    };

    if (status) {
      const response = await CallService.updateRecordingConsent(payload);
      if (response?.success) {
        await store.dispatch("voiceAgents/setVoiceAgentConsentStatus", true);
      }
    } else {
      eventBus.emit("voice-agent-consent-cancel");
    }
  } catch (error) {
    console.error(
      "An error occurred while updating voice agent consent: ",
      error,
    );
  } finally {
    closeModal();
  }
};
</script>

